/* unplugin-vue-components disabled */import { render } from "./UserAgreement.vue?vue&type=template&id=7a99836f&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"

import "./UserAgreement.vue?vue&type=style&index=0&id=7a99836f&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a99836f"]])

export default __exports__